<template>
  <component
    :is="listWrapperComponent"
    v-bind="{
      ...defaultProps,
      ...$attrs,
    }"
    :value="isVisible"
    @input="emitChangeVisible"
  >
    <template #activator="props">
      <slot
        name="activator"
        v-bind="props"
      />
    </template>
    <slot />
  </component>
</template>

<script>
import { VBottomSheet, VMenu } from 'vuetify/lib'

export default {
  name: 'MenuBottomSheet',
  components: {
    VBottomSheet,
    VMenu,
  },
  inheritAttrs: false,
  model: {
    prop: 'isVisible',
    event: 'menu-bottom-sheet:change-visible',
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isMobile: window.MOBILE_VERSION,
  }),
  computed: {
    listWrapperComponent() {
      return this.isMobile ? 'VBottomSheet' : 'VMenu'
    },
    defaultProps() {
      if (this.isMobile) {
        return {}
      }

      return {
        bottom: true,
        'offset-y': true,
        rounded: true,
      }
    },
  },
  methods: {
    emitChangeVisible(value) {
      this.$emit('menu-bottom-sheet:change-visible', value)
    },
  },
}
</script>
